var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('LoadingDialog',{attrs:{"value":_vm.loading}}),_c('router-view'),(_vm.pwaInstallable && _vm.layout === 'User')?_c('ThePWAInstallBanner'):_vm._e(),_c('TheServiceWorkerUpdateSnackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }